import User from "@/models/lms/User";
import Media from "@/models/lms/Media";
import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Course from "@/models/lms/Course";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

/**
 * An announcement
 * @property {number} id
 * @property {string} title
 * @property {string} content
 * @property {string} start_date
 * @property {string} end_date
 * @property {boolean} is_read
 */
export default class Announcement extends GenexLMSModel {
    static entity = 'announcements'

    static fields() {
        return {
            id: this.attr(null),
            title: this.attr(null),
            content: this.attr(null),
            start_date: this.attr(null),
            end_date: this.attr(null),
            audience: this.attr(null),
            creator_id: this.attr(null),
            creator: this.belongsTo(User, 'creator_id'),
            created_at: this.attr(null),
            media: this.hasManyBy(Media, 'media_ids'),
            course_id: this.attr(null),
            course: this.belongsTo(Course, 'course_id'),
            media_ids: this.attr([]),
            group_id: this.attr(null),
            is_read: this.attr(false),
            // models: this.hasMany(AnnouncementModel, 'announcement_id'),

        }
    }


    /**
     * Returns all announcements for the user
     * @function
     * @param {Object} pagination
     * @param {number} pagination.page - Which page to retrieve
     * @param {number} pagination.limit - How many entities to retrieve
     * @param {?Object} [query={}] - Query terms for the request
     * @param {?string} [query.date]
     * @param {Array.<string>} [relationships=[]] - Relationships to bring along
     * @returns {Promise<Response>}
     */

    static FetchAll({page = 1, limit = 15}, query = {}, relationships = []) {
        return this.api().get(`/announcements`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                persistBy: 'insertOrUpdate',
                params: {
                    ...{
                        page: page, limit: limit, with: relationships
                    }, ...(query !== {} ? query : {}),
                },
                dataTransformer: ({data: {data}}) => {
                    return data.map(announcement => {
                        if (relationships.includes('media')) {
                            if (relationships.includes('media')) {
                                if (Object.prototype.hasOwnProperty.call(announcement.attributes, 'media')) {
                                    announcement.attributes.media.map(item => {
                                        Object.assign(item, item.attributes)
                                        item.mediable_type = 'announcements'
                                        item.mediable_id = announcement.id
                                    })
                                }

                            }

                        }
                        if (Object.prototype.hasOwnProperty.call(announcement.attributes, 'models')) {
                            announcement.attributes.models.map(item => {
                                Object.assign(item, item.attributes)

                                if (item.model_type !== 'Global') {
                                    item.model_type = item.model_type.slice(item.model_type.lastIndexOf('\\') + 1)
                                }

                            })
                            if (announcement.attributes.models.length === 0) {
                                announcement.attributes.models = [{
                                    model_id: null,
                                    model_type: 'Global',
                                    announcement_id: announcement.id
                                }]
                            }
                        }


                        if (relationships.includes('creator')) {
                            if (Object.prototype.hasOwnProperty.call(announcement.attributes, 'creator')) {
                                if (announcement.attributes.creator !== null) {
                                    Object.assign(announcement.attributes.creator, announcement.attributes.creator.attributes)
                                }
                            }
                        }
                        if (relationships.includes('course')) {
                            if (Object.prototype.hasOwnProperty.call(announcement.attributes, 'course')) {
                                if (announcement.attributes.course !== null) {
                                    Object.assign(announcement.attributes.course, announcement.attributes.course.attributes)
                                }
                            }
                        }

                        return {...announcement, ...announcement.attributes}
                    })
                },
            }
        )
    }


    /**
     * Update an existing announcement
     * @function
     * @param {Object} announcement - The announcement object
     * @param {boolean} saved - Whether to persist the response
     * @returns {Promise<Response>} - The newly created application
     */

    static Update(announcement, saved = true) {
        return this.api().patch(`/announcements/${announcement.id}`, announcement, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),

                dataTransformer: ({data: {data}}) => {
                    if (Object.prototype.hasOwnProperty.call(data.attributes, 'models')) {
                        data.attributes.models.map(item => {
                            Object.assign(item, item.attributes)
                            if (item.model_type === null) {
                                item.model_type = 'Global'
                            }
                            if (item.model_type === "") {
                                item.model_type = 'Global'
                            }
                            if (item.model_type !== 'Global') {
                                item.model_type = item.model_type.slice(item.model_type.lastIndexOf('\\') + 1)
                            }

                        })
                    }
                    return {...data, ...data.attributes}
                },
                save: saved
            }
        )
    }
    /**
     * Mark an announcement as read
     * @function
     * @param {number} id - The announcement id
     * @returns {Promise<Response>} - The newly read announcement
     */

    static MarkRead(id) {
        return this.api().post(`/announcements/${id}/read`,{}, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                persistBy:'update',
                dataTransformer: ({data: {data}}) => {

                    return {...data, ...data.attributes}

                },
            }
        )
    }


}
